import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Box, Collapse, ListItemButton, ListItemText } from '@mui/material'
import _ from 'lodash'

import { defaultOptionStates } from '../utils'

import type { CreateListItemProps, CreateListItemPropsFunction, Option, Options } from '../types'
import type { FieldValues } from 'react-hook-form'

type Props<T extends FieldValues> = Pick<
  CreateListItemProps<T>,
  'disabled' | 'field' | 'filter' | 'recursionDeep'
> & {
  currentValue: Options
  onCreateListItem: CreateListItemPropsFunction<T>
  path: string
}

export const CollapsibleNode = <T extends FieldValues>({
  currentValue,
  disabled,
  field,
  filter,
  onCreateListItem,
  path,
  recursionDeep,
}: Props<T>) => {
  const { onChange, value: formValue } = field

  const isCollapsedPath: string = `${path}.isCollapsed`
  let isCollapsed: boolean = _.get(formValue, isCollapsedPath)
  if (isCollapsed === undefined) {
    isCollapsed = defaultOptionStates.isCollapsed
  }

  return (
    <Box sx={{ pl: recursionDeep * 3 }}>
      <ListItemButton
        disabled={disabled}
        onClick={() => void onChange(_.set(formValue, isCollapsedPath, !isCollapsed))}
      >
        {isCollapsed ? <ExpandMore /> : <ExpandLess />}
        <ListItemText primary={(currentValue as unknown as Option).label} />
      </ListItemButton>

      <Collapse
        in={!isCollapsed}
        unmountOnExit
      >
        {onCreateListItem({
          disabled,
          field,
          filter,
          options: currentValue as unknown as T,
          parentPath: path,
          recursionDeep: recursionDeep + 1,
        })}
      </Collapse>
    </Box>
  )
}
